<template lang="html">
  <div v-if="getCurrentRT.is_sandbox">
    <div
      class="dot-container row middle-xs center-xs"
      @click="show_modal = true"
    >
      <i class="fas fa-info info-icon dtc v-mid"></i>
      <div class="interactive-demo-dot dt"></div>
    </div>
    <pl-dialog
      v-if="show_modal"
      maxHeight="80%"
      minWidth="600px"
      :disableOutsideClick="true"
      @close="show_modal = false"
    >
      <div class="h-100">
        <component :is="componentName" @close="show_modal = false" />
      </div>
    </pl-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import Prompt from './pages/onlineWalkthroughPrompt';
  import ShareableGraphics from './pages/onlineWalkthroughShareableGraphics';
  import StudentList from './pages/onlineWalkthroughStudentlist';
  import OnlineConfiguration from './pages/onlineWalkthroughConfiguration';
  import Submission from './pages/onlineWalkthroughSubmissionCard.vue';

  export default {
    data() {
      return {
        show_modal: false,
      };
    },
    components: {
      Prompt,
      ShareableGraphics,
      StudentList,
      OnlineConfiguration,
      Submission,
    },
    computed: {
      ...mapGetters(['getCurrentRT']),
    },
    props: {
      componentName: {
        type: String,
        default: '',
      },
    },
    methods: {},
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  .dot-container
    position: relative
    height: 21px
    width: 21px
    border-radius: 50%
    cursor: pointer
    &:hover
      background-color: pl-ruby
      .interactive-demo-dot
        visibility: hidden
      .info-icon
        visibility: visible

  .info-icon
    position: absolute
    visibility: hidden
    font-size: 10px
    z-index: 100
    color: white
</style>



// WEBPACK FOOTER //
// onlineWalkthroughDot.vue?afaadcc6